import React, {Component} from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import template from './EmployeesHeader.rt';

export default class EmployeesHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      term: ''
    };

    this.debouncedSearch = debounce(this.searchEmployees, 250);
  }

  setSearchTerm = (term) => {
    this.setState({term}, () => {
      this.debouncedSearch(term);
    });
  }

  searchEmployees(term) {
    this.props.getEmployees(0, 50, term);
  }

  render = template
}

EmployeesHeader.propTypes = {
  getEmployees: PropTypes.func.isRequired
}
